import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {Card, Grid, Dropdown, Button, Tab} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import {downloadFile} from '../../common/util/file';
import ServiceTab from './tabs/service';
import GeneralData from './generalData';
import OutputTab from './tabs/output';
import InputTab from './tabs/input';
import './index.scss';

const currentYear = moment().year();

const panes = [
  {'menuItem': 'Ingreso'},
  {'menuItem': 'Servicio'},
  {'menuItem': 'Salida'},
];

const PANES_INDICES = {
  'INPUT': 0,
  'SERVICE': 1,
  'OUTPUT': 2,
};

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
      'chassisTmp': '',
      'chassisSelected': '',
      'yearTmp': currentYear,
      'yearSelected': currentYear,
    };
  }

  componentDidMount() {
    const {permissions} = this.props;
    if (
      !hasAccessPermission(permissions, resources.vehicleHistory, scopes.See)
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.fetchChassisList();
  }

  getYears = () => {
    const years = [];
    const initialYear = 2015;
    const numberOfYears = currentYear - initialYear;
    for (let i = numberOfYears; i >= 0; i--) {
      years.push(initialYear + i);
    }

    const yearsOptions = Object.keys(years).map((position) => {
      const year = years[position];
      return {'text': year, 'value': year};
    });
    yearsOptions.unshift({'text': 'Todos', 'value': 'ALL'});
    return yearsOptions;
  };

  getChassisOptions = () => {
    return this.props.chassisList.map((item) => {
      return {'text': item.chassis, 'value': item.chassis};
    });
  };

  fetchChassisList = () => {
    const {yearSelected} = this.state;
    const params = yearSelected === 'ALL' ? {} : {'year': yearSelected};
    this.props.fetchVehicleChassis(params);
  };

  fetchChassisData = () => {
    const {chassisSelected} = this.state;
    this.props.fetchGeneralDataByChassis(chassisSelected);
  };

  updateDataSelected = (field) => {
    const temporalValue = this.state[`${field}Tmp`];
    const selectedValue = this.state[`${field}Selected`];

    if (selectedValue === temporalValue) {
      return;
    }
    const newState = {};
    newState[`${field}Selected`] = temporalValue;

    if (field === 'year') {
      newState.chassisTmp = '';
      newState.chassisSelected = '';
      this.setState(newState, () => this.fetchChassisList());
      return;
    }
    newState.activeTabIndex = 0;
    this.setState(newState, () => this.fetchChassisData());
  };

  onChangeTemporalValues = (value, field) => {
    const newState = {};
    newState[`${field}Tmp`] = value;
    this.setState(newState, () => this.updateDataSelected(field));
  };

  onReportGenerateClick = () => {
    const {chassisSelected} = this.state;
    const baseUrl = process.env.REP_API_URL;
    const fileUrl = `${baseUrl}/vehicles/chassis/${chassisSelected}/document`;
    downloadFile(fileUrl);
  };

  onTabChange = (event, data) => {
    const {activeTabIndex} = this.state;
    if (activeTabIndex === data.activeIndex) {
      return;
    }
    this.setState({'activeTabIndex': data.activeIndex});
  };

  renderPanesContent() {
    const {activeTabIndex, chassisSelected} = this.state;

    switch (activeTabIndex) {
      default:
      case PANES_INDICES.INPUT:
        return <InputTab chassis={chassisSelected} />;
      case PANES_INDICES.SERVICE:
        return <ServiceTab chassis={chassisSelected} />;
      case PANES_INDICES.OUTPUT:
        return <OutputTab chassis={chassisSelected} />;
    }
  }

  render() {
    const {loadingChassis, loadingGeneralData, generalData} = this.props;
    const {chassisTmp, chassisSelected, yearTmp, activeTabIndex} = this.state;

    return (
      <div className='vehicle-history-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Historial de Vehículos</h2>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={1}>
                    <h4>Chasis</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Dropdown
                      value={chassisTmp}
                      options={this.getChassisOptions()}
                      selection
                      search
                      loading={loadingChassis}
                      disabled={loadingChassis || loadingGeneralData}
                      noResultsMessage='Chasis no encontrado'
                      onChange={(e, {value}) =>
                        this.onChangeTemporalValues(value, 'chassis')
                      }
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <h4>Año</h4>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Dropdown
                      value={yearTmp}
                      options={this.getYears()}
                      selection
                      search
                      loading={loadingChassis}
                      disabled={loadingChassis || loadingGeneralData}
                      noResultsMessage='Año no encontrado'
                      onChange={(e, {value}) =>
                        this.onChangeTemporalValues(value, 'year')
                      }
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                    {chassisSelected && <h4>Estado:</h4>}
                  </Grid.Column>
                  <Grid.Column width={2}>
                    {chassisSelected &&
                      !loadingGeneralData &&
                      generalData.status}
                  </Grid.Column>
                  <Grid.Column width={2}>
                    {chassisSelected && <h4>Disponibilidad:</h4>}
                  </Grid.Column>
                  <Grid.Column width={1}>
                    {chassisSelected &&
                      !loadingGeneralData &&
                      generalData.availability}
                  </Grid.Column>
                  <Grid.Column width={3} textAlign='right'>
                    <Button
                      primary
                      disabled={!chassisSelected}
                      onClick={this.onReportGenerateClick}
                    >
                      Generar Reporte
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        {chassisSelected && <GeneralData />}

        {chassisSelected && (
          <Card raised fluid>
            <Tab
              menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
              panes={panes}
              activeIndex={activeTabIndex}
              onTabChange={this.onTabChange}
            />
            {this.renderPanesContent()}
          </Card>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingChassis': state.vehicleHistory.loadingChassis,
    'chassisList': state.vehicleHistory.chassisList,
    'loadingGeneralData': state.vehicleHistory.loadingGeneralData,
    'generalData': state.vehicleHistory.generalData,
    'permissions': state.session.permissions,
  };
};
  
const {
  navigateTo,
  fetchVehicleChassis,
  fetchGeneralDataByChassis,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchVehicleChassis,
  fetchGeneralDataByChassis,
})(Index);
